import { getRequestConnectedDocFlows } from '../../api'
import { DOCUMENT_STAPLINGS_LIST_API } from '../../constants/api'
import { EMPTY_OBJECT } from '../../constants/common'
import { postApi } from '../../utils/api'

export function getDocFlowSelectModalItems({
  excludeIds,
  params: { search, ...params },
}) {
  return postApi({
    data: {
      ...params,
      filters: {
        ...(excludeIds?.length > 0 ? { exclude_id: excludeIds } : null),
        ...(search ? { search } : null),
      },
    },
    endpoint: DOCUMENT_STAPLINGS_LIST_API,
  })
}

export function getDocFlowSelectModalConnectedItems({
  id,
  params: { search, ...params },
}) {
  return getRequestConnectedDocFlows({
    data: { ...params, filters: search ? { search } : EMPTY_OBJECT },
    id,
  })
}
